export const DEFAULT_EMAIL_LABELS = ['work', 'personal', 'other'];
